/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
export class SbbDateRange<D> {
  constructor(readonly start: D, readonly end: D) {}
}
